export class Pesquisa {
    constructor(public texto: string,
                public cdsetor: string) {}
}

export class ResultadoPesquisa {
    constructor(public id: number,
                public titulo: string,
                public descricao: string,
                public data: string,
                public tipo: string) {}
}
